module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/ed95edfa4e0133b8264b71a4635eb40a.png";